import {Injectable, OnInit} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';

@Injectable()
export class LocalizationService2 {
  private dictionaryDe = new Map();
  constructor() {
    this.LOCALE = {
      lblAdressStreet: 'Straße',
      lblAdressNumber: 'Hausnr.',
    lblAdressZip: 'PLZ',
    lblAdressTown: 'Ort',
    lblAdressCountry: 'Land',
    lblCustomerNr: 'Kundennr.',
    lblCustomerNrAbbr: 'Nr.',
    lblCustomerTitle: 'Anrede',
    lblCustomerFirstName: 'Vorname',
    lblCustomerLastName: 'Nachname',
    lblCustomerPhone: 'Telefon',
    lblCustomerEmail: 'E-Mail',
    lblCustomerFax: 'Fax',
    lblCustomerMobile: 'Mobiltelefon',
    lblOfferName: 'Projekt',
    lblOfferKommission: 'Projekt',
    lblOfferProjectNumber: 'Projektnr.',
    lblOfferCustomer: 'Kunde',
    lblOfferDate: 'Datum',
    lblOfferPositions: 'Positionen',
    lblOfferDocOffer: 'Angebot',
    lblOfferDocOrder: 'Auftragsbestätigung',
    lblOfferDocBill: 'Rechnung',
    lblOfferDocDelivery: 'Lieferschein',
    lblSettingsJobs: 'Dienstleistungen',
    lblSettingsAddJob: 'Dienstleistung hinzufügen',
    lblSettingsOffer: 'Angebotstext',
    lblSettingsOrder: 'Auftragstext',
    lblSettingsBill: 'Rechnungstext',
    lblSettingsDelivery: 'Lieferscheintext',
    lblSettingsPretext: 'Vortext',
    lblSettingsPosttext: 'Nachtext',
    lblJobTitle: 'Beschreibung',
    lblJobPrice: 'Preis',
    lblJobUnit: 'Einheit',
    lblJobCount: 'Anzahl',
    lblJobOverview: 'Übersicht Ihrer Dienstleistungen',
    lblJobSelectionOffer: 'zum Angebot',
    lblPositionHeading: 'zu Position',
    lblNoteOverview: 'Übersicht Ihrer Textmodule',
    lblNoteTitle: 'Name',
    lblNoteText: 'Text',
    lblSettingsNotes: 'Textmodule',
    lblJobSelectionHeader: 'Dienstleistungen',
    lblDoorConfigurationTitle: 'Tür konfigurieren',
    lblDoorConfigurationBaseType: 'Grundform',
    lblDoorConfigurationConstructionType: 'Bauform',
    lblDoorConfigurationMeasure: 'Maße',
    lblDoorConfigurationColors: 'Farben',
    lblDoorConfigurationPanel: 'Füllung',
    lblDoorConfigurationAccessory: 'Zubehör',
    lblDoorConfigurationButtonPrevious: 'Zurück',
    lblDoorConfigurationButtonNext: 'Weiter',
    lblDoorConfigurationButtonFinish: 'Fertigstellen',
    lblDoorConfigurationButtonSave: 'Speichern',
    lblDoorConfigurationButtonCancel: 'Abbrechen',
    lblDoorConfigurationBaseTypeTitle: 'Blendrahmenaußenmaß',
    lblDoorConfigurationBaseTypeWidth: 'Breite in mm',
    lblDoorConfigurationBaseTypeHeight: 'Höhe in mm',
    lblDoorConfigurationBaseTypeRectangle: 'Rechteckbauform',
    lblDoorConfigurationBaseTypeArc: 'Bogenelemente',
    lblDoorConfigurationBaseTypeToolBox: 'Baukasten',
    lblDoorConfigurationConstructionTypeTitle: 'Grundform',
    lblDoorConfigurationConstructionTypeTopLight: 'Oberlicht',
    lblDoorConfigurationConstructionTypeTopLightType: 'Oberlichttyp',
    lblDoorConfigurationConstructionTypeTopLightGlas: 'Oberlichtglas',
    lblDoorConfigurationConstructionTypeWindowFrame: 'Blendrahmen',
    lblDoorConfigurationConstructionTypeWindowFrameSelection: 'Blendrahmenauswahl',
    lblDoorConfigurationConstructionTypeWindowFrameExtension: 'Blendrahmenverbreiterung',
    lblDoorConfigurationConstructionTypeWindowFrameSelectionWindowTitle: 'Auswahl der Blendrahmenverbreiterung',
    lblDoorConfigurationConstructionTypeWindowFrameLeft: 'Links',
    lblDoorConfigurationConstructionTypeWindowFrameTop: 'Oben',
    lblDoorConfigurationConstructionTypeWindowFrameRight: 'Rechts',
    lblDoorConfigurationConstructionTypeWindowFrameBottom: 'Unten',
    lblDoorConfigurationConstructionTypeWindowFramePhonotherm: 'Phonotherm',
    lblDoorConfigurationConstructionTypeWindowFramePhonothermUnit: 'mm',
    lblDoorConfigurationConstructionTypeProfileSystems: 'Profilsysteme',
    lblDoorConfigurationConstructionTypeProfile: 'Profilsystem',
    lblDoorConfigurationConstructionDuoDamb: 'Duo-Pfosten',
    lblDoorConfigurationConstructionRoundedGlas: 'runde Glasleisten',
    lblDoorConfigurationMeasurePanelBoarders: 'Füllungsränder optimieren',
    lblDoorConfigurationMatchingGlasWidth: 'Seitenteile mit gleichen Glasbreiten',
    lblDoorConfigurationColorOutside: 'Außen',
    lblDoorConfigurationColorInside: 'Innen',
    lblDoorConfigurationColorFrame: 'Haustürrahmen',
    lblDoorConfigurationColorFrameHpl: 'Blendrahmen',
    lblDoorConfigurationColorPanel: 'Füllungsplatte',
    lblDoorConfigurationColorPanelHpl: 'Türblatt',
    lblDoorConfigurationColorOrnateFrame: 'Zierrahmen',
    lblDoorConfigurationColorSame: 'gleiche Farbe',
    lblDoorConfigurationColorInsideOutsideSame: 'Innenfarben wie Außenfarben',
    lblDoorConfigurationPanelDoorWing: 'Türflügel',
    lblDoorConfigurationPanelWingHeading: 'Flügelüberdeckend',
    lblDoorConfigurationPanelWingCovered: 'außen',
    lblDoorConfigurationPanelWingCoveredInside: 'innen',
    lblDoorConfigurationPanelProfile: 'Füllung',
    lblDoorConfigurationPanelGlas: 'Glas',
    lblDoorConfigurationPanelSpecialGlas: 'Sonderglas',
    lblDoorConfigurationPanelOrnateBar: 'Zierleisten',
    lblDoorConfigurationPanelCombinedPanel: 'Kombi-Füllung',
    lblDoorConfigurationPanelEmbeddedStainlessSteelHeading: 'Edelstahl eingelassen',
    lblDoorConfigurationPanelEmbeddedStainlessSteel: 'außen',
    lblDoorConfigurationPanelEmbeddedStainlessSteelOutsideOnly: 'innen',
    lblDorrConfigurationAccessoryDinDirection: 'DIN-Richtung Tür',
    lblDorrConfigurationAccessoryOrderNumber: 'Best-Nr.',
    lblDorrConfigurationAccessoryDescription: 'Beschreibung',
    lblMasterDetailsShowPictogram: 'Pictogramme anzeigen',
    lblDoorConfigurationConstructionTypeBlindWing: 'Blindflügel',
    lbllblDorrConfigurationAccessoryPlaceholder: 'Best-Nr oder Beschreibung durchsuchen',
    lblDoorConfigurationPanelProfileHeader: 'Profile',
    lblDoorConfigurationPanelGlasHeader: 'Glas',
    lblMasterTwoDetailOutsideHeader: 'Außenansicht',
    lblMasterTwoDetailInsideHeader: 'Innenansicht',
    lblPanelDinNotPossibleWithDoorpartDin_part1: 'Diese Füllung ist bei Stulptüren nur für den',
    lblPanelDinNotPossibleWithDoorpartDin_part2: 'Türflügel auswählbar.',
    lblPanelDinNotPossibleWithStulptürLeft: 'linken',
    lblPanelDinNotPossibleWithStulptürRight: 'rechten',
    lblDoorConfigurationBaseTypeIgnoreFilter: 'Gesamtmaße feststehend',
    lblButtonLeftSidePanel: 'Seitenteil links',
    lblButtonRightSidePanel: 'Seitenteil rechts',
    lblButtonOberlicht: 'Oberlicht',
    lblColorSelection: 'Farbauswahl',
    lblColorSelectionGroupB: 'Trendfarben',
    lblColorSelectionGroupA: 'RAL',
    lblColorSelectionDecor: 'Dekor',
    lblColorSelectionCarbon: 'Carbon',
    lblColorSelectionStone: 'Naturstein',
    lblColorSelectionDefaultColors: 'Standardfarben',
    lblDinRichtungLinks: 'DIN links',
    lblDinRichtungRechts: 'DIN rechts',
    lblAccessoryConfigurationSize: 'Zubehörgröße',
    lblAccessoryConfigurationColor: 'Zubehörfarbe',
    lblAccessoryConfigurationPlaceholderNotAvailable: 'nicht verfügbar',
    lblDoorConfigurationPanelMainWing: 'Hauptflügel',
    lblBlendrahmenVerbreiterungAnputzleiste: 'Anputzleiste 15 mm (nur für Therm,',
    lblBlendrahmeVerbreiterungKunststoffunterbau: 'Kunststoffunterbau',
    lblBlendrahmeVerbreiterungPhonotherm: 'Phonotherm',
    lblBlendrahmeVerbreiterungDicke: 'Dicke',
    lblBlendrahmeVerbreiterungHoehe: 'Höhe(max. 300,',
    lblTuerfuellungSelection: 'Türfüllung',
    lblTuerfuellungSelectionSeitenteil: 'Seitenteilfüllung',
    lblTuerfuellungSelectionLinks: 'links',
    lblTuerfuellungSelectionMittig: 'mittig',
    lblTuerfuellungSelectionRechts: 'rechts',
    lblBlendrahmenverbreiterungTitle: 'Blendrahmenvebreiterung',
    lblDoorConfigurationAccessoryList: 'Liste',
    lblDoorConfigurationAccessorySymbols: 'Symbole',
    lblCustomerSelection: 'Kundenauswahl',
    lblAddNewCustomer: 'Neuen Kunden anlegen',
    lblUseExistingCustomer: 'vorhandenen Kunden auswählen',
    lblAddProductDoors: 'Haustüranlagen',
    lblAddProductOffer: 'Angebot',
    lblAddProductAccessory: 'Zubehör',
    lblAddProducCustom: 'Sonstiges',
    lblAddProducUpload: 'Bild laden',
    lblAddProducName: 'Name',
    lblSettingsGeneral: 'Allgemein',
    lblOfferCopy: 'Angebot kopieren',
    lblOfferDelete: 'Angebot löschen',
    lblDoorOverView: 'Türen',
    lblOfferTableCaption: 'Position',
    lblOfferTablePropertyCaption: 'Eigenschaften',
    lblOfferTableDeleteCaption: 'Löschen',
    lblOfferPositionCount: 'Anzahl',
    lblOfferPositionAlternative: 'als Alternative',
    lblPanelBarIsolation: 'Wärmeschutz',
    lblPanelBarSecurity: 'Sicherheit',
    lblSameColorSelectionAlertTitle: 'HPL-Dekore sind nur beidseitig möglich',
    lblThermOnlyProfileForThermAccessoryAlert: 'Durch den Profilwechsel wird das Türband auf zweiteilige Türbänder geändert. Soll das Profil trotzdem gewechselt werden?',
      lblThermOnlyProfileForThermAccessoryAlertTitle: 'Profilauswahl',
    lblStangengriffInnenhandhabeAlertTitle: 'Innendrücker wählen',
    lblStangengriffInnenhandhabeAlertDescription: 'Für die gewählte Außenhandhabe stehen folgende Innendrücker zur Verfügung. Der vorhandene Innendrücker wird automatisch ersetzt. Bitte wählen Sie aus:',
    lblPanelNoiseProtection: 'Schallschutz',
    lblPanelNoiseProtectionAlertTitle: 'Schallschutz Konfiguration',
    lblPanelNoiseProtectionAlertMsg: 'Die Ausführung als Schallschutztür ist nur mit der Standard-Aluminium-Bodenschwelle möglich. Soll die Bodenschwelle angepasst werden?',
    lblApplyNoiseProtection: 'Bodenschwelle ändern',
    lblCancelNoiseProtection: 'Vorgang abbrechen',
    lblPanelBarLocking: 'Verriegelung',
    lblPanelBarLaibung: 'Laibung',
    lblOfferPositionLaibungDetails1: 'Aluminium-Haustür-Laibung',
    lblOfferPositionLaibungDetails2: 'Laibung als alternative',
    lblOfferPositionSecurity1: 'RC2',
    lblOfferPositionSecurityRc3: 'RC3',
    lblOfferPositionSecurity2: 'Ausführung als einbruchhemmende Haustüranlage',
    lblOfferPositionSecurity3: 'Ausführung mit erhöhter Sicherheit',
    lblOfferPositionNoiseProtection0: 'Ausführung mit Standard-Türblatt',
    lblOfferPositionNoiseProtection1: 'Ausführung mit Schallschutz-Türblatt',
    lblOfferPositionGlastype: 'Glasart',
    lblOfferPositionBodenschwelle: 'Bodenschwelle',
    lblOfferPositionThermProfil1: 'therm-Profilsystem',
    lblOfferPositionThermProfil2: 'Einsatz eines Profilsystems mit verbesserter Wärmeisolierung',
    lblOfferPositionThermProfil3: 'Wärmeschutzfüllung',
    lblOfferPositionThermProfil4: 'Füllungsstärke mind. 60 mm und 3-fach Verglasung in den Füllungen',
    lblOfferPositionThermProfil5: 'Wärmeschutz-Verglasung',
    lblOfferPositionThermProfil6: 'Einsatz von 3-fach Verglasung (High-Therm oder Safe-High_Therm,',
    lblOfferPositionThermOption: 'Wärmeschutzoption',
    lblOfferPositionUwertCaption: 'Aktueller U-Wert',
    lblOfferPositionUwertUnit: 'W/(qmxK,',
    lblOfferPositionUwertUncalculable : 'keine Berechnung möglich!',
    lblDoorConfigurationColorJambFrame: 'Pfosten / Sprossen',
    lblDoorConfigurationPanelModell: 'Modell',
    lblDoorConfigurationPanelModellreihe: 'Modellreihe',
    lblDoorConfigurationOpenShowroom: 'Abdocken',
    lblDoorConfigurationToplight: 'Oberlicht-Höhe:',
    lblNavbarCustomer: 'Kundenverwaltung',
    lblNavbarDoor: 'Türen',
    lblNavbarOffer: 'Projekte',
    lblNavbarPresentation: 'Präsentation',
    lblNavbarSettings: 'Einstellungen',
    lblNavbarMerchant: 'Händlerbereich',
    lblInitCustomer: 'Ausgewählter Kunde',
    lblNoInitCustomer: 'Zur Zeit ist kein Kunde ausgewählt.',
    lblCustomerEdit: 'Kundendaten erfassen',
    lblOfferStatusShow: 'Bestellstatus anzeigen',
    lblDoorEdit: 'Tür bearbeiten',
    lblDoorOffer: 'Angebot erstellen',
    lblDoorSave: 'Freigeben',
    lblBaseTypeInvalidHeightGt: 'Die eingegebene Höhe ist zu groß.',
    lblBaseTypeInvalidHeightSt: 'Die eingegebene Höhe ist zu klein.',
    lblValueToBig: 'Der eingegebene Wert ist zu groß.',
    lblValueToSmall: 'Der eingegebene Wert ist zu klein.',
    lblTempSavedDoors: 'Türen von',
    lblDoorPreview: 'Vorschau',
    lblDoorName: 'Projekt',
    lblDoorDescription: 'Beschreibung',
    lblDoorlastChange: 'letzte Änderung',
    lblDoorConfigurationBreite: '-Breite:',
    lblColorSelectionSelectedColors: 'zuletzt gewählte Farben:',
    lblBaseTypeInvalidWidth: 'Die eingegebene Breite ist zu klein.',
    lblDoorConfigurationAccessoryOverview: 'Zubehör-Übersicht',
    lblAccessoryOrderNumber: 'Artikelnummer',
    lblAccessoryVisible: 'Sichtbares Zubehör',
    lblAccessoryInvisible: 'Nicht sichtbares Zubehör',
    lblfuellungsueberstandFluegelueberdeckend: 'vorbereitet für Flügelüberdeckend(nur außen,',
    lblfuellungsueberstandOben: 'Oben in mm',
    lblfuellungsueberstandUnten: 'Unten in mm',
    lblfuellungsueberstandLinks: 'Links in mm',
    lblfuellungsueberstandRechts: 'Rechts in mm',
    lblfuellungsueberstand: 'Überstand',
    lblPdfWindowHeader: 'Glasinfo',
    lblDoorConfigurationAussenansicht: 'Außenansicht',
    lblDoorConfigurationInnenansicht: 'Innenansicht',
    lblDoorConfigurationPictureRefresh: 'Bild wird aktualisiert...',
    lblLieferzeit: 'Lieferzeit',
    lblFernwarung: 'Fernwartung',
    lblDoorConfigurationColorPartial: 'Abgesetzter Bereich',
    lblBlendrahmenverbreiterungProfile: 'Profile',
    lblBlendrahmenverbreiterungKombination: 'Kombination',
    lblBlendrahmenverbreiterungOben: 'Oben',
    lblBlendrahmenverbreiterungLinks: 'Links',
    lblBlendrahmenverbreiterungRechts: 'Rechts',
    lblBlendrahmenverbreiterungUnten: 'Unten',
    lblDoorConfigurationGrundform: 'Grundform (Außenansicht,',
    lblHome: 'Startseite',
    lblRadierer: 'Alle temporär gespeicherten Türen löschen',
    lblDelete: 'Löschen',
    lblApply: 'Übernehmen',
    lblNameBezeichungSuchbar: 'Name oder Beschreibung eingeben',
    lblColorSuchbar: 'Name oder Nummer eingeben',
    lblGlasSuchePlaceholder: 'Name eingeben',
    lblNettopreis: 'voraussichtlicher Nettopreis:',
    lblAddDoor: 'Haustüranlage erstellen',
    lblOwnImages: 'Eigene Bilder',
    lblExistingImages: 'Existierende Bilder',
    lblLoadOwnFile: 'Eigene Datei laden',
    lblOfferThermNotSelected: 'nicht gewählt',
    lblSettingsLayout: 'Layout',
    lblSettingsLayoutAdressTop: 'Adresse, von oben',
    lblSettingsLayoutAdressLeft: 'Adresse, von links',
    lblSettingsLayoutMarginFromTop: 'Abstand von oben',
    lblSettingsLayoutMarginFromLeft: 'Abstand von links',
    lblSettingsLayoutMarginFromBottom: 'Abstand von unten',
    lblSettingsLayoutMarginFromRight: 'Abstand von rechts',
    lblSettingsLayoutDateTop: 'Datum, von oben',
    lblSettingsLayoutDateLeft: 'Datum, von links',
    lblSettingsLayoutFonTop: 'Telefon/Fax, von oben',
    lblSettingsLayoutFonLeft: 'Telefon/Fax, von links',
    lblSettingsLayoutOfferTop: 'Angebotstext, von oben',
    lblSettingsLayoutOfferLeft: 'Angebotstext, von links',
    lblSettingsLayoutOffer2Top: 'Angebotstext 2. Seite, von oben',
    lblSettingsLayoutOffer2Left: 'unterer Seitenrand',
    lblSettingsLayoutPrintOption: 'Druckoptionen',
    lblSettingsLayoutPrintOption1: 'Schnittzeichnung der Profile',
    lblSettingsLayoutPrintOption2: 'Hinweise zur Holzstruktur',
    lblSettingsLayoutPrintOption3: 'Warnungen zur Zubehörkombinierbarkeit',
    lblSettingsLayoutPrintOption4: 'Hinweise zum U-Wert',
    lblSettingsLayoutPrintOption5: 'Information zum Kaba experT',
    lblSettingsLayoutHeaderFooter: 'Kopf- und Fußzeile',
    lblSettingsLayoutHeader: 'Briefkopf',
    lblSettingsLayoutFooter: 'Fußzeile',
    lblSettingsLayoutPdfExportOnly: 'nur bei PDF-Export',
    lblSprossenHeader: 'Sprossen',
    lblSprossenVerteilen: 'Sprossen positionieren',
    lblAddSprosse: 'Sprossen hinzufügen',
    lblSprossenInfo: 'Sie können die hinzugefügten Sprossen direkt im Türbild verschieben.',
    lblSprossenSenkrecht: 'Senkrecht',
    lblSprossenTSprosse: 'T-Sprosse',
    lblSprossenWidth: 'Sprossenbreiten',
    lblSprossenPosition: 'Position',
    lblSprosseWaagerecht: 'Waagerecht',
    lblSprosseFalling: 'Schräg fallend',
    lblSprosseRising: 'Schräg steigend',
    lblSprosseGleicheVerteilung: 'Gleichmäßige Sprossenverteilung',
    lblSprosseEdit: ' Sprosse bearbeiten',
    lblSprosseBreite: 'Breite in mm',
    lblSprosseAbstand: 'Abstand rechts/oben in mm',
    lblSprosseForward: 'Nach vorne',
    lblSprosseToFront: 'In den Vordergrund',
    lblSprosseSendBack: 'Nach hinten',
    lblSprosseToBackground: 'In den Hintergrund',
    lblSprosseDelete: 'Sprosse löschen',
    lblFarblichabgesetzt1: 'Diese Füllung ist farblich absetzbar. Wechseln Sie in den Reiter',
    lblFarblichAbgesetzt2: 'um die Füllungsfarbe zu ändern.',
    lblDoorCopy: 'Tür kopieren',
    lblDoorConfigurationPanelWingCoveredInfo: 'Eine flügelüberdeckende Füllung im Seitenteil ist ' +
      'nur mit einem senkrechten Blindflügel möglich, Änderung der Blindflügel unter Bauform.', lblEmailHeader: 'E-Mail senden', lblEmailBetreff: 'Betreff', lblEmailTo: 'An', lblEmailCc: 'Cc', lblEmailBcc: 'Bcc', lblEmailSend: 'Senden', lblEmailSendOwnProgram: 'E-Mail-Programm', lblEmailPickerName: 'Name', lblEmailPickerEmail: 'E-Mail', lblAddProductTitle: 'Position hinzufügen', lblCopyProduct: 'Position kopieren', lblEditProduct: 'Position bearbeiten', lblRemoveProduct: 'Position löschen',
lblOfferJobAdd: 'Dienstleistung zum Angebot hinzufügen',
lblPositionJobAdd: 'Dienstleistung zur Position hinzufügen',
lblOfferPrePostText: 'Vor- und Nachtexte',
lblImpressum: 'Impressum',
lblVersionsinfo: 'Versionsinfo',
lblSettingsLayoutDeleteHeader: 'Kopfzeile löschen',
lblSettingsLayoutDeleteFooter: 'Fußzeile löschen',
lblSettingsMainHeader: 'Einstellungen',
lblSettingsPreisCurrencyUnit: 'Währung',
lblSettingsPreisCurrencyValue: 'Währungsfaktor',
lblSettingsPreisValue: 'Preisfaktor',
lblSettingsPreisVendorDiscount: 'HändlerRabatt',
lblSettingsPreisTollValue: 'Mehrwertsteuersatz in %',
lblSettingsPreisTollUnit: 'Bezeichnung (Steuer,',
lblSettingsPreisEinzelPreiseAnzeigen: 'Einzelpreise (Ja/Nein,',
lblSettingsPreisNettoPreiseAnzeigen: 'vorauss. Netto-Preis anzeigen',
lblSettingsPreisAktion1: 'Aktion 21150',
lblSettingsPreisAktionHeader: 'Aktionen',
lblSettingsPreisAktion2: 'Winter-Aktion 2015',
lblSettingsPreis: 'Preisbildung',
lblDeleteConfirmationMsg: 'Möchten Sie diese Tür wirklich löschen?',
lblDeleteConfirmationMsgTextmodul: 'Möchten Sie dieses Textmodul wirklich löschen?',
lblDeleteConfirmationMsgDoorWithOffer: 'Zu dieser Tür wurde ein Angebot erstellt. ' +
      'Wenn Sie die Tür löschen, wird sie auch aus dem Angebot gelöscht. Möchten Sie diese Tür wirklich löschen?',
lblPositionDeleteConfirmationMsg: 'Möchten Sie diese Position wirklich löschen?',
lblJobDeleteConfirmationMsg: 'Möchten Sie diese Dienstleistung wirklich löschen?',
lblDeleteUnsavedConfirmationMsg: 'Möchten Sie wirklich alle temporären Türen löschen?',
lblPreisAufAnfrage: 'Preis auf Anfrage',
lblPermanentSavedOffers: 'Dauerhaft gespeicherte Angebote',
lblTempOffers: 'Temporär gespeicherte Angebote',
lblEditCustomer: 'Kunden bearbeiten',
lblDeleteCustomer: 'Kunden löschen',
lblDeleteCustomerConfirmationMsg: 'Möchten Sie diesen Kunden wirklich löschen',
lblCustomerCompany: 'Firmenname',
lblCustomerStammdaten: 'Stammdaten',
lblCustomerKontakt: 'Kontakt',
lblCustomerAdress: 'Anschrift und Rechnungsadresse',
lblCustomerFirma: 'Firma',
lblCustomerPrivatPerson: 'Privatperson',
lblCustomerLieferadresse: 'Abweichende Lieferadresse',
lblPassword: 'Passwort',
lblOk: 'Ok',
lblNewPassword: 'Neues Passwort',
lblRepeatNewPassword: 'Wiederholung',
lblPaswordDidNotMatch: 'Die Passwörter stimmten nicht überein. Bitte versuchen Sie es erneut.',
lblWrongPassword: 'Falsches Passwort.',
lblSprossenHidenText: 'Bitte wählen Sie eine der Modellreihen geschlossen, ' +
      'nur Glas oder Motivverglasung, um eine Sprosse zu erfassen',
lblBaseFunction: 'Grundfunktionen',
lblBereich: 'Bereich markieren',
lblEbenen: 'Ebenen',
lblLizenznummer: 'Lizenznummer',
lblFirma: 'Firma',
lblTelefon: 'Telefon',
lblFax: 'Fax',
lblAnschrift: 'Anschrift',
lblStrasse: 'Straße',
lblPLZ: 'PLZ',
lblStadt: 'Stadt',
lblSchweizer: 'Schweizer Einstellungen',
lblStatusabfrage: 'Statusabfrage',
lblHintergrund: 'Hintergrund',
lblVordach: 'Vordach',
lblNachtdarstellung: 'Nachtdarstellung',
lblRechteck: 'Rechteck',
lblSchliessen: 'Form schliessen',
lblCompanyName: 'Hartwig & Führer GmbH & Co. KG',
lblProgrammversion: 'Programmversion',
lblDatenbankversion: 'Datenbankversion',
lblKundendienst: 'Technischer Kundendienst',
lblMessezentrum: 'Messezentrum',
lblProgrammfreigeschaltet: 'Das Programm ist freigeschaltet bis zum',
lblChooseColors: 'Farben wählen',
lblSchatten: 'Schatten',
lblTextur: 'Textur',
lblFarbe: 'Farbe',
lblInHintergrund: 'in den Hintergrund',
lblInVordergrund: 'in den Vordergrund',
lblFixieren: 'Fixieren',
lblPerspektivisch: 'Perspektivisch',
lblRechteckig: 'Rechteckig',
lblAccessoires: 'Accessoires',
lblLampen: 'Lampen',
lblWandverkleidung: 'Wandverkleidung',
lblFassadenelemente: 'Fassadenelemente',
lblOverviewOfServices: 'Übersicht Ihrer Dienstleistungen',
lblKommission: 'Projekt',
lblDienstleistungen: 'Dienstleistungen',
lblTextmodule: 'Textmodule',
lblSettingsAddTextmodul: 'Textmodul hinzufügen',
lblBeforeAfterTexts: 'Vor-/Nachtexte',
lblDownload: 'Download',
lblSonderverbreiterung: 'Sonderverbreiterung',
lblmm: 'mm',
lblGesamt: 'Gesamt',
lblCustomerDuplicate: 'In Ihren Kundendaten existieren bereits ' +
      'ähnliche Einträge. Meinten Sie eventuell einen der folgenden Kunden?',
   lblNeuerKunde: 'Neuer Kunde',
   lblVorhandeneKunden: 'Vorhandene Kunden',

   lblAngebotsnummer: 'Angebotsnummer',
   lblBestellt: 'Bestellt',
   lblErfasst: 'Erfasst',
   lblLiefertermin: 'vorauss. Liefertermin',
   lblProduktionsstart: 'Produktionsstart',
   lblProduktionsende: 'Produktionsende',
   lblVerladen: 'Verladen',
   lblBerechnet: 'Berechnet',
   lblAngebot: 'Angebot',
   lblRechnung: 'Rechnung',
   lblKW: 'KW',
   lblLadeStatus: 'Lade Status...das kann nach einem Neustart der Anwendung etwas dauern.',
   lblSinglePosition: 'Position',
   lblCreatPresentation: 'Präsentation erstellen',
   lblDeleteConfirmationMsgMulti: 'Möchten Sie diese Türen wirklich löschen?',
   lblDeleteConfirmationMsgOfferMulti: 'Möchten Sie diese Angebote wirklich löschen?',
   lblDeleteConfirmationMsgOffer: 'Möchten Sie dieses Angebot wirklich löschen?',
   lblDeleteConfirmationPositionMsg: 'Möchten Sie diese Position wirklich löschen? ' +
      'Gelöschte Türen sind nicht mehr in der Türenübersicht zu sehen.',
   lblOfferAdd: 'Angebot hinzufügen',
   lblOfferEdit: 'Angebot bearbeiten',
   lblOfferSave: 'Angebot dauerhaft speichern',
   lblOfferConstruction: 'Konstruktion',
   lblOfferGeneralInfo: 'Allgemeine Angaben',
   lblDeleteAllOffers: 'Alle temporär gespeicherten Angebot löschen',
   lblPlsInsertHausnummer: 'Bitte geben Sie die gewünschte Hausnummer an.',
   lblHausnummer: 'Hausnummer',
   lblUWertArea: 'A (gesamt,',
   lblUWertHta: 'U-Wert HTA',
   lblPositionDetailsProperies: 'Türeigenschaften',
   lblVerriegelungArtNr: 'Art.Nr.',
   lblVerriegelungMehrpreis: 'Mehrpreis',
   lblVerriegelungAlsAlternative: 'als Alternative',
   lblNewCustomer: 'Neuer Kunde',
   lblDoorNotSaveableReason: 'Für diese Tür kann kein Angebot erstellt werden da noch ' +
      'Fehlermeldungen existieren. Bitte klicken Sie auf den Button mit dem Stift (Tür bearbeiten,, ' +
      'die Fehlermeldungen werden rechts unten angezeigt.',
   lblDokumenttext: 'Dokumententexte',
   lblVersion: 'Version:',
   lblNavbarVordach: 'Vordach',
   lblJobImage: 'Bild',
   lblSettingsJobDelete: 'Bild entfernen',
   lblPrintDoor: 'Bild drucken',
   lblDownloadDoor: 'Bild herunterladen',
   lblKeinHolzdekotBeiClassicLine: 'Holzdekore sind bei der Zierleiste Classic Line nicht möglich.',
   lblDoorConfigurationPanelWingCoveredDuoInfo: 'Bei flügelüberdeckenden Füllungen können nur ' +
      'die Profilsysteme KO 80 HD, KO 80 HDA, KOtherm und Softtherm eingesetzt werden.',
  lblAccessoryDoesNotMatchInColor: 'Dieses Zubehörteil passt farblich nicht zu den bereits ausgewählten!',
  lblAccessoryNotWithTherm: 'Diese Türbänder können nur bei Therm-Profilen eingesetzt werden!',
  lblAccessoryOnlyWithSpecificModel: 'Das Zubehör 22089 kann nur bei Modelltüren 3400 und 3600 eingesetzt werden.',
  lblAccessoryNotDeliverable: 'Dieses Zubehörteil ist nicht mehr lieferbar!',
  lblAccessoryHomeThermNotAccessible: 'Dieser Artikel ist für HOMEtherm Türen nicht auswählbar.',
  lblAccessoryRc3Accessible: 'Dieser Artikel ist für Türen der Einbruchhemmung RC3 nicht auswählbar.',
  lblAccessoryErsatzartikel: 'Ersatzartikel',
  lblDoorConfigurationColorPartialCarbon: 'Carbon Applikation',
  lblDoorConfigurationColorPartialStone: 'Naturstein Applikation',
  lblFabrlichAbsetzbarAlert: 'Achtung, Füllungsplatte farblich absetzbar.',
  lblJa: 'Ja',
  lblNein: 'Nein',
  lblKratzschutzEinlegen: 'Soll der Kratzschutz eingelegt werden? Aufpreis ',
  lblKratzschutzNichtBeiFluegelueberdeckend: 'Dieser Zubehörartikel ist nur für flügelüberdeckende Füllungen möglich.',
  lblAdditionalHingeWarning: 'Dieses Türband passt nicht zu den vorhanden Türbändern und kann nicht ausgewählt werden.',
  lblAddAlsAlternative: 'Als Alternative hinzufügen',
  lblInklusive: 'Inklusive',
  lblSpiegelWarning: 'Das Zubehör 23089 kann bei Modelltüren und Glastüren nicht eingesetzt werden.',
  lblChangeGlas: 'Anderes Glas wählen',
  lblChangeFuellung: 'Andere Füllung wählen',
  lblAddJamb: 'Oberlichttyp ändern',
  lblSichtbarerFuellungsbereichAlert1: 'Der verfügbare Bereich im',
  lblSichtbarerFuellungsbereichAlert2Glas: 'ist zu groß für das gewählte Glas. Die Maximalmaße des Glases sind',
  lblSichtbarerFuellungsbereichAlert2Fuellung: 'ist zu klein für die gewählte Füllung. Die Minimalmaße der Füllung sind',
  lblKeepGlas: 'Glas trotzdem übernehmen',
  lblOpeningInside: 'Einwärts öffnend',
  lblOpeningOutside: 'Auswärts öffnend',
  lblPanel: 'Füllung',
  lblMotivverglasung: 'Motivverglasung',
  lblStandardverglasung: 'Standardverglasung',
  lblSonderverglasung: 'Sonderverglasung',
  lblSeitenteile: 'Seitenteile anzeigen',
  lblSelectDifferentSpiegel: 'Bitte wählen Sie Artikel 23089.',
  lblKeepFuellung: 'Füllung trotzdem übernehmen',
  lblSelectProjectName: 'Bitte geben Sie einen Projektnamen für die Haustüranlage an. ',
  lblLichteHoehe: 'Lichte Höhe in mm',
  lblLichteBreite: 'Lichte Breite in mm',
  lblHoehenpaketHeader: 'Höhenpaket',
  lblHoehenpaketNeeded: 'Aufgrund der eingestellten Höhe, sollte ein Höhenpaket erfasst werden.',
  lblHoehenpaketRecommendation: 'Außerdem möchten wir Ihnen dreiteilige Türbänder (Artikel 10206, empfehlen. Diese können Sie im Reiter Zubehör erfassen.',
    lblHoehenpaketDisclaimer: 'Wünschen Sie kein Höhenpaket, kann von Hartwig & Führer keine Gewährleistung übernommen werden.',
    lblApplyHoehenpaket: 'Höhenpaket erfassen',
    lblCancelHoehenpaket: 'Kein Höhenpaket erwünscht',
    lblDoorConfigurationAccessoryImages: 'Bilder',
    lblVoreinstellungen: 'Voreinstellungen',
    lblExportImport: 'Export/ Import',
    lblAllgemein: 'Allgemein',
    lblZubehor: 'Zubehor',
    lblSonstiges: 'Sonstiges',
    lblExakt: 'Exakte Suche',
    lblDoorPreis: 'Preis',
    lblNoteDeleteConfirmationMsg: 'Möchten Sie dieses Textmodule wirklich löschen?',
    lblSelectTitleName: 'Bitte geben Sie den Titel und die Beschreibung der neue Dienstleistung an.',
    lblDoorConfigurationPositionDetails: 'Eigenschaften',
    lblNameEmptyNotAllowed: 'Das Projekt darf nicht leer sein. Die Änderung wurde nicht gespeichert.',
    lblDocuments: 'Dokumente',
    lblWordExport: 'Word Export',
    lblShowDocument: 'Dokument anzeigen',
    lblSendAsEmail: 'Per E-Mail versenden',
    lblOfferBestellung: 'Bestellung',
    lblEstimatedDeliveryDate: 'ca. Liefertermin',
    lblKopieAn: 'Kopie an',
    lblBestellen: 'Bestellen',
    lblOnlineBestellung: 'Online-Bestellung',
    lblFuellungsgroessenWarningFuellung: 'Füllungsgröße - Füllung',
    lblFuellungsgroessenWarningGlas: 'Füllungsgröße - Glas',
    lblFuellungsgroessenWarningOberlicht: 'Füllungsgröße - Oberlichtglas',
    lblBestellenExplanation: 'Mit dem Klick auf Bestellen wird eine E-Mail an KOMPOtherm versandt. Geben Sie im Feld ' +
      'Kopie an Ihre E-Mail Adresse ein, wenn Sie eine Kopie der Nachricht erhalten möchten.',
    lblDoorHasOffer: 'Angebot vorhanden',
    lblAdminUserOverview: 'Übersicht',
    lblAdminUserNewUser: 'Neue Nutzer anlegen',
    lblAdminUserEditUser: 'Nutzer Einstellungen bearbeiten',
    lblAdminUserInfo: 'Info / Hilfe',
    lblAdminUserTableEdit: 'Bearbeiten',
    lblAdminUserTableUserNr: 'Nutzungsnummer',
    lblAdminUserTableCompany: 'Firma',
    lblAdminUserTablePhone: 'Telefonnummer',
    lblAdminUserTableFax: 'Faxnummer',
    lblAdminUserTableMail: 'Email',
    lblAdminUserTableSwiss: 'Schweizer Einstellungen',
    lblAdminUserTableUserName: 'Benutzername',
    lblAdminUserTableFirstName: 'Vorname',
    lblAdminUserTableLastName: 'Nachname',
    lblAdminUserTableActive: 'Aktiv',
    lblAdminUserTableDelete: 'Löschen',
    lblAdminUserUserEdit: 'Nutzer bearbeiten',
    lblAdminUserSaveEdit: 'Speichern',
    lblAdminUserCancel: 'Abbrechen',
    lblAdminUserAddNew: 'Anlegen',
    lblAdminUserEmptyUserNameNotAllowed: 'Benutzername muss angegeben werden',
    lblAdminUserMinlength: 'Das Feld muss mindestens 3 Zeichen haben',
    lblAdminUserEmptyLastNameNotAllowed: 'Nachname muss angegeben werden',
    lblAdminUserEmptyMailNotAllowed: 'Email muss angegeben werden',
    lblAdminUserNoValidEmail: 'Keine gültige Email',
    lblAdminUserNoValidPhoneNumber: 'Ungültige Telefonnummer',
    lblAdminUserPasswordNotValid: 'Ungültiges Passwort',
    lblAdminUserPhoneNumberPattern: '[0-9 +]*',
    lblAdminUserGetNewPassword: 'Zufälliges Passwort',
    lblAdminUserSavePassword: 'Passwort ändern',
      lblDeleteCustomerError: 'Es können keine Nutzer Gelöscht werden Welche einem Angebot zugewiesen sind.'

    };
    this.dictionaryDe.set('lblAdressStreet', 'Straße');
    this.dictionaryDe.set('lblAdressNumber' , 'Hausnr.');
      this.dictionaryDe.set('lblAdressZip' , 'PLZ');
      this.dictionaryDe.set('lblAdressTown' , 'Ort');
      this.dictionaryDe.set('lblAdressCountry' , 'Land');
      this.dictionaryDe.set('lblCustomerNr' , 'Kundennr.');
      this.dictionaryDe.set('lblCustomerNrAbbr' , 'Nr.');
      this.dictionaryDe.set('lblCustomerTitle' , 'Anrede');
      this.dictionaryDe.set('lblCustomerFirstName' , 'Vorname');
      this.dictionaryDe.set('lblCustomerLastName' , 'Nachname');
      this.dictionaryDe.set('lblCustomerPhone' , 'Telefon');
      this.dictionaryDe.set('lblCustomerEmail' , 'E-Mail');
      this.dictionaryDe.set('lblCustomerFax' , 'Fax');
      this.dictionaryDe.set('lblCustomerMobile' , 'Mobiltelefon');
      this.dictionaryDe.set('lblOfferName' , 'Projekt');
      this.dictionaryDe.set('lblOfferKommission' , 'Projekt');
      this.dictionaryDe.set('lblOfferProjectNumber' , 'Projektnr.');
      this.dictionaryDe.set('lblOfferCustomer' , 'Kunde');
      this.dictionaryDe.set('lblOfferDate' , 'Datum');
      this.dictionaryDe.set('lblOfferPositions' , 'Positionen');
      this.dictionaryDe.set('lblOfferDocOffer' , 'Angebot');
      this.dictionaryDe.set('lblOfferDocOrder' , 'Auftragsbestätigung');
      this.dictionaryDe.set('lblOfferDocBill' , 'Rechnung');
      this.dictionaryDe.set('lblOfferDocDelivery' , 'Lieferschein');
      this.dictionaryDe.set('lblSettingsJobs' , 'Dienstleistungen');
      this.dictionaryDe.set('lblSettingsAddJob' , 'Dienstleistung hinzufügen');
      this.dictionaryDe.set('lblSettingsOffer' , 'Angebotstext');
      this.dictionaryDe.set('lblSettingsOrder' , 'Auftragstext');
      this.dictionaryDe.set('lblSettingsBill' , 'Rechnungstext');
      this.dictionaryDe.set('lblSettingsDelivery' , 'Lieferscheintext');
      this.dictionaryDe.set('lblSettingsPretext' , 'Vortext');
      this.dictionaryDe.set('lblSettingsPosttext' , 'Nachtext');
      this.dictionaryDe.set('lblJobTitle' , 'Beschreibung');
      this.dictionaryDe.set('lblJobPrice' , 'Preis');
      this.dictionaryDe.set('lblJobUnit' , 'Einheit');
      this.dictionaryDe.set('lblJobCount' , 'Anzahl');
      this.dictionaryDe.set('lblJobOverview' , 'Übersicht Ihrer Dienstleistungen');
      this.dictionaryDe.set('lblJobSelectionOffer' , 'zum Angebot');
      this.dictionaryDe.set('lblPositionHeading' , 'zu Position');
      this.dictionaryDe.set('lblNoteOverview' , 'Übersicht Ihrer Textmodule');
      this.dictionaryDe.set('lblNoteTitle' , 'Name');
      this.dictionaryDe.set('lblNoteText' , 'Text');
      this.dictionaryDe.set('lblSettingsNotes' , 'Textmodule');
      this.dictionaryDe.set('lblJobSelectionHeader' , 'Dienstleistungen');
      this.dictionaryDe.set('lblDoorConfigurationTitle' , 'Tür konfigurieren');
      this.dictionaryDe.set('lblDoorConfigurationBaseType' , 'Grundform');
      this.dictionaryDe.set('lblDoorConfigurationConstructionType' , 'Bauform');
      this.dictionaryDe.set('lblDoorConfigurationMeasure' , 'Maße');
      this.dictionaryDe.set('lblDoorConfigurationColors' , 'Farben');
      this.dictionaryDe.set('lblDoorConfigurationPanel' , 'Füllung');
      this.dictionaryDe.set('lblDoorConfigurationAccessory' , 'Zubehör');
      this.dictionaryDe.set('lblDoorConfigurationButtonPrevious' , 'Zurück');
      this.dictionaryDe.set('lblDoorConfigurationButtonNext' , 'Weiter');
      this.dictionaryDe.set('lblDoorConfigurationButtonFinish' , 'Fertigstellen');
      this.dictionaryDe.set('lblDoorConfigurationButtonSave' , 'Speichern');
      this.dictionaryDe.set('lblDoorConfigurationButtonCancel' , 'Abbrechen');
      this.dictionaryDe.set('lblDoorConfigurationBaseTypeTitle' , 'Blendrahmenaußenmaß');
      this.dictionaryDe.set('lblDoorConfigurationBaseTypeWidth' , 'Breite in mm');
      this.dictionaryDe.set('lblDoorConfigurationBaseTypeHeight' , 'Höhe in mm');
      this.dictionaryDe.set('lblDoorConfigurationBaseTypeRectangle' , 'Rechteckbauform');
      this.dictionaryDe.set('lblDoorConfigurationBaseTypeArc' , 'Bogenelemente');
      this.dictionaryDe.set('lblDoorConfigurationBaseTypeToolBox' , 'Baukasten');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeTitle' , 'Grundform');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeTopLight' , 'Oberlicht');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeTopLightType' , 'Oberlichttyp');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeTopLightGlas' , 'Oberlichtglas');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFrame' , 'Blendrahmen');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFrameSelection' , 'Blendrahmenauswahl');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFrameExtension' , 'Blendrahmenverbreiterung');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFrameSelectionWindowTitle' , 'Auswahl der Blendrahmenverbreiterung');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFrameLeft' , 'Links');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFrameTop' , 'Oben');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFrameRight' , 'Rechts');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFrameBottom' , 'Unten');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFramePhonotherm' , 'Phonotherm');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeWindowFramePhonothermUnit' , 'mm');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeProfileSystems' , 'Profilsysteme');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeProfile' , 'Profilsystem');
      this.dictionaryDe.set('lblDoorConfigurationConstructionDuoDamb' , 'Duo-Pfosten');
      this.dictionaryDe.set('lblDoorConfigurationConstructionRoundedGlas' , 'runde Glasleisten');
      this.dictionaryDe.set('lblDoorConfigurationMeasurePanelBoarders' , 'Füllungsränder optimieren');
      this.dictionaryDe.set('lblDoorConfigurationMatchingGlasWidth' , 'Seitenteile mit gleichen Glasbreiten');
      this.dictionaryDe.set('lblDoorConfigurationColorOutside' , 'Außen');
      this.dictionaryDe.set('lblDoorConfigurationColorInside' , 'Innen');
      this.dictionaryDe.set('lblDoorConfigurationColorFrame' , 'Haustürrahmen');
      this.dictionaryDe.set('lblDoorConfigurationColorPanel' , 'Füllungsplatte');
      this.dictionaryDe.set('lblDoorConfigurationColorOrnateFrame' , 'Zierrahmen');
      this.dictionaryDe.set('lblDoorConfigurationColorSame' , 'gleiche Farbe');
      this.dictionaryDe.set('lblDoorConfigurationColorInsideOutsideSame' , 'Innenfarben wie Außenfarben');
      this.dictionaryDe.set('lblDoorConfigurationPanelDoorWing' , 'Türflügel');
      this.dictionaryDe.set('lblDoorConfigurationPanelWingHeading' , 'Flügelüberdeckend');
      this.dictionaryDe.set('lblDoorConfigurationPanelWingCovered' , 'außen');
      this.dictionaryDe.set('lblDoorConfigurationPanelWingCoveredInside' , 'innen');
      this.dictionaryDe.set('lblDoorConfigurationPanelProfile' , 'Füllung');
      this.dictionaryDe.set('lblDoorConfigurationPanelGlas' , 'Glas');
      this.dictionaryDe.set('lblDoorConfigurationPanelSpecialGlas' , 'Sonderglas');
      this.dictionaryDe.set('lblDoorConfigurationPanelOrnateBar' , 'Zierleisten');
      this.dictionaryDe.set('lblDoorConfigurationPanelCombinedPanel' , 'Kombi-Füllung');
      this.dictionaryDe.set('lblDoorConfigurationPanelEmbeddedStainlessSteelHeading' , 'Edelstahl eingelassen');
      this.dictionaryDe.set('lblDoorConfigurationPanelEmbeddedStainlessSteel' , 'außen');
      this.dictionaryDe.set('lblDoorConfigurationPanelEmbeddedStainlessSteelOutsideOnly' , 'innen');
      this.dictionaryDe.set('lblDorrConfigurationAccessoryDinDirection' , 'DIN-Richtung Tür');
      this.dictionaryDe.set('lblDorrConfigurationAccessoryOrderNumber' , 'Best-Nr.');
      this.dictionaryDe.set('lblDorrConfigurationAccessoryDescription' , 'Beschreibung');
      this.dictionaryDe.set('lblMasterDetailsShowPictogram' , 'Pictogramme anzeigen');
      this.dictionaryDe.set('lblDoorConfigurationConstructionTypeBlindWing' , 'Blindflügel');
      this.dictionaryDe.set('lbllblDorrConfigurationAccessoryPlaceholder' , 'Best-Nr oder Beschreibung durchsuchen');
      this.dictionaryDe.set('lblDoorConfigurationPanelProfileHeader' , 'Profile');
      this.dictionaryDe.set('lblDoorConfigurationPanelGlasHeader' , 'Glas');
      this.dictionaryDe.set('lblMasterTwoDetailOutsideHeader' , 'Außenansicht');
      this.dictionaryDe.set('lblMasterTwoDetailInsideHeader' , 'Innenansicht');
      this.dictionaryDe.set('lblPanelDinNotPossibleWithDoorpartDin_part1' , 'Diese Füllung ist bei Stulptüren nur für den');
      this.dictionaryDe.set('lblPanelDinNotPossibleWithDoorpartDin_part2' , 'Türflügel auswählbar.');
      this.dictionaryDe.set('lblPanelDinNotPossibleWithStulptürLeft' , 'linken');
      this.dictionaryDe.set('lblPanelDinNotPossibleWithStulptürRight' , 'rechten');
      this.dictionaryDe.set('lblDoorConfigurationBaseTypeIgnoreFilter' , 'Gesamtmaße feststehend');
      this.dictionaryDe.set('lblButtonLeftSidePanel' , 'Seitenteil links');
      this.dictionaryDe.set('lblButtonRightSidePanel' , 'Seitenteil rechts');
      this.dictionaryDe.set('lblButtonOberlicht' , 'Oberlicht');
      this.dictionaryDe.set('lblColorSelection' , 'Farbauswahl');
      this.dictionaryDe.set('lblColorSelectionGroupB' , 'Trendfarben');
      this.dictionaryDe.set('lblColorSelectionGroupA' , 'RAL');
      this.dictionaryDe.set('lblColorSelectionDecor' , 'Dekor');
      this.dictionaryDe.set('lblColorSelectionCarbon' , 'Carbon');
      this.dictionaryDe.set('lblColorSelectionStone' , 'Naturstein');
      this.dictionaryDe.set('lblColorSelectionDefaultColors' , 'Standardfarben');
      this.dictionaryDe.set('lblDinRichtungLinks' , 'DIN links');
      this.dictionaryDe.set('lblDinRichtungRechts' , 'DIN rechts');
      this.dictionaryDe.set('lblAccessoryConfigurationSize' , 'Zubehörgröße');
      this.dictionaryDe.set('lblAccessoryConfigurationColor' , 'Zubehörfarbe');
      this.dictionaryDe.set('lblAccessoryConfigurationPlaceholderNotAvailable' , 'nicht verfügbar');
      this.dictionaryDe.set('lblDoorConfigurationPanelMainWing' , 'Hauptflügel');
      this.dictionaryDe.set('lblBlendrahmenVerbreiterungAnputzleiste' , 'Anputzleiste 15 mm (nur für Therm);');
      this.dictionaryDe.set('lblBlendrahmeVerbreiterungKunststoffunterbau' , 'Kunststoffunterbau');
      this.dictionaryDe.set('lblBlendrahmeVerbreiterungPhonotherm' , 'Phonotherm');
      this.dictionaryDe.set('lblBlendrahmeVerbreiterungDicke' , 'Dicke');
      this.dictionaryDe.set('lblBlendrahmeVerbreiterungHoehe' , 'Höhe(max. 300);');
      this.dictionaryDe.set('lblTuerfuellungSelection' , 'Türfüllung');
      this.dictionaryDe.set('lblTuerfuellungSelectionSeitenteil' , 'Seitenteilfüllung');
      this.dictionaryDe.set('lblTuerfuellungSelectionLinks' , 'links');
      this.dictionaryDe.set('lblTuerfuellungSelectionMittig' , 'mittig');
      this.dictionaryDe.set('lblTuerfuellungSelectionRechts' , 'rechts');
      this.dictionaryDe.set('lblBlendrahmenverbreiterungTitle' , 'Blendrahmenvebreiterung');
      this.dictionaryDe.set('lblDoorConfigurationAccessoryList' , 'Liste');
      this.dictionaryDe.set('lblDoorConfigurationAccessorySymbols' , 'Symbole');
      this.dictionaryDe.set('lblCustomerCompany' , 'Firma');
      this.dictionaryDe.set('lblCustomerSelection' , 'Kundenauswahl');
      this.dictionaryDe.set('lblAddNewCustomer' , 'Neuen Kunden anlegen');
      this.dictionaryDe.set('lblUseExistingCustomer' , 'vorhandenen Kunden auswählen');
      this.dictionaryDe.set('lblAddProductDoors' , 'Haustüranlagen');
      this.dictionaryDe.set('lblAddProductOffer' , 'Angebot');
      this.dictionaryDe.set('lblAddProductAccessory' , 'Zubehör');
      this.dictionaryDe.set('lblAddProducCustom' , 'Sonstiges');
      this.dictionaryDe.set('lblAddProducUpload' , 'Bild laden');
      this.dictionaryDe.set('lblAddProducName' , 'Name');
      this.dictionaryDe.set('lblSettingsGeneral' , 'Allgemein');
      this.dictionaryDe.set('lblOfferCustomer' , 'Kunde');
      this.dictionaryDe.set('lblOfferCopy' , 'Angebot kopieren');
      this.dictionaryDe.set('lblOfferDelete' , 'Angebot löschen');
      this.dictionaryDe.set('lblDoorOverView' , 'Türen');
      this.dictionaryDe.set('lblOfferTableCaption' , 'Position');
      this.dictionaryDe.set('lblOfferTablePropertyCaption' , 'Eigenschaften');
      this.dictionaryDe.set('lblOfferTableDeleteCaption' , 'Löschen');
      this.dictionaryDe.set('lblOfferPositionCount' , 'Anzahl');
      this.dictionaryDe.set('lblOfferPositionAlternative' , 'als Alternative');
      this.dictionaryDe.set('lblPanelBarIsolation' , 'Wärmeschutz');
      this.dictionaryDe.set('lblPanelBarSecurity' , 'Sicherheit');
      this.dictionaryDe.set('lblPanelBarLocking' , 'Verriegelung');
      this.dictionaryDe.set('lblPanelBarLaibung' , 'Laibung');
      this.dictionaryDe.set('lblOfferPositionLaibungDetails1' , 'Aluminium-Haustür-Laibung');
      this.dictionaryDe.set('lblOfferPositionLaibungDetails2' , 'Laibung als alternative');
      this.dictionaryDe.set('lblOfferPositionSecurity1' , 'RC2');
      this.dictionaryDe.set('lblOfferPositionSecurity2' , 'Ausführung als einbruchhemmende Haustüranlage');
      this.dictionaryDe.set('lblOfferPositionSecurity3' , 'Ausführung mit erhöhter Sicherheit');
      this.dictionaryDe.set('lblOfferPositionGlastype' , 'Glasart');
      this.dictionaryDe.set('lblOfferPositionBodenschwelle' , 'Bodenschwelle');
      this.dictionaryDe.set('lblOfferPositionThermProfil1' , 'therm-Profilsystem');
      this.dictionaryDe.set('lblOfferPositionThermProfil2' , 'Einsatz eines Profilsystems mit verbesserter Wärmeisolierung');
      this.dictionaryDe.set('lblOfferPositionThermProfil3' , 'Wärmeschutzfüllung');
      this.dictionaryDe.set('lblOfferPositionThermProfil4' , 'Füllungsstärke mind. 60 mm und 3-fach Verglasung in den Füllungen');
      this.dictionaryDe.set('lblOfferPositionThermProfil5' , 'Wärmeschutz-Verglasung');
      this.dictionaryDe.set('lblOfferPositionThermProfil6' , 'Einsatz von 3-fach Verglasung (High-Therm oder Safe-High_Therm);');
      this.dictionaryDe.set('lblOfferPositionThermOption' , 'Wärmeschutzoption');
      this.dictionaryDe.set('lblOfferPositionUwertCaption' , 'Aktueller U-Wert');
      this.dictionaryDe.set('lblOfferPositionUwertUnit' , 'W/(qmxK);');
      this.dictionaryDe.set('lblDoorConfigurationColorJambFrame' , 'Pfosten / Sprossen');
      this.dictionaryDe.set('lblDoorConfigurationPanelModell' , 'Modell');
      this.dictionaryDe.set('lblDoorConfigurationPanelModellreihe' , 'Modellreihe');
      this.dictionaryDe.set('lblDoorConfigurationOpenShowroom' , 'Abdocken');
      this.dictionaryDe.set('lblDoorConfigurationToplight' , 'Oberlicht-Höhe:');
      this.dictionaryDe.set('lblNavbarCustomer' , 'Kundenverwaltung');
      this.dictionaryDe.set('lblNavbarDoor' , 'Türen');
      this.dictionaryDe.set('lblNavbarOffer' , 'Projekte');
      this.dictionaryDe.set('lblNavbarPresentation' , 'Präsentation');
      this.dictionaryDe.set('lblNavbarSettings' , 'Einstellungen');
      this.dictionaryDe.set('lblNavbarMerchant' , 'Händlerbereich');
      this.dictionaryDe.set('lblInitCustomer' , 'Ausgewählter Kunde');
      this.dictionaryDe.set('lblNoInitCustomer' , 'Zur Zeit ist kein Kunde ausgewählt.');
      this.dictionaryDe.set('lblCustomerEdit' , 'Kundendaten erfassen');
      this.dictionaryDe.set('lblOfferStatusShow' , 'Bestellstatus anzeigen');
      this.dictionaryDe.set('lblDoorEdit' , 'Tür bearbeiten');
      this.dictionaryDe.set('lblDoorOffer' , 'Angebot erstellen');
      this.dictionaryDe.set('lblDoorSave' , 'Freigeben');
      this.dictionaryDe.set('lblBaseTypeInvalidHeightGt' , 'Die eingegebene Höhe ist zu groß.');
      this.dictionaryDe.set('lblBaseTypeInvalidHeightSt' , 'Die eingegebene Höhe ist zu klein.');
      this.dictionaryDe.set('lblValueToBig' , 'Der eingegebene Wert ist zu groß.');
      this.dictionaryDe.set('lblValueToSmall' , 'Der eingegebene Wert ist zu klein.');
      this.dictionaryDe.set('lblTempSavedDoors' , 'Türen von');
      this.dictionaryDe.set('lblDoorPreview' , 'Vorschau');
      this.dictionaryDe.set('lblDoorName' , 'Projekt');
      this.dictionaryDe.set('lblDoorDescription' , 'Beschreibung');
      this.dictionaryDe.set('lblDoorlastChange' , 'letzte Änderung');
      this.dictionaryDe.set('lblDoorConfigurationBreite' , '-Breite:');
      this.dictionaryDe.set('lblColorSelectionSelectedColors' , 'zuletzt gewählte Farben:');
      this.dictionaryDe.set('lblBaseTypeInvalidWidth' , 'Die eingegebene Breite ist zu klein.');
      this.dictionaryDe.set('lblDoorConfigurationAccessoryOverview' , 'Zubehör-Übersicht');
      this.dictionaryDe.set('lblAccessoryOrderNumber' , 'Artikelnummer');
      this.dictionaryDe.set('lblAccessoryVisible' , 'Sichtbares Zubehör');
      this.dictionaryDe.set('lblAccessoryInvisible' , 'Nicht sichtbares Zubehör');
      this.dictionaryDe.set('lblfuellungsueberstandFluegelueberdeckend' , 'vorbereitet für Flügelüberdeckend(nur außen);');
      this.dictionaryDe.set('lblfuellungsueberstandOben' , 'Oben in mm');
      this.dictionaryDe.set('lblfuellungsueberstandUnten' , 'Unten in mm');
      this.dictionaryDe.set('lblfuellungsueberstandLinks' , 'Links in mm');
      this.dictionaryDe.set('lblfuellungsueberstandRechts' , 'Rechts in mm');
      this.dictionaryDe.set('lblfuellungsueberstand' , 'Überstand');
      this.dictionaryDe.set('lblPdfWindowHeader' , 'Glasinfo');
      this.dictionaryDe.set('lblDoorConfigurationAussenansicht' , 'Außenansicht');
      this.dictionaryDe.set('lblDoorConfigurationInnenansicht' , 'Innenansicht');
      this.dictionaryDe.set('lblDoorConfigurationPictureRefresh' , 'Bild wird aktualisiert...');
      this.dictionaryDe.set('lblLieferzeit' , 'Lieferzeit');
      this.dictionaryDe.set('lblFernwarung' , 'Fernwartung');
      this.dictionaryDe.set('lblDoorConfigurationColorPartial' , 'Abgesetzter Bereich');
      this.dictionaryDe.set('lblBlendrahmenverbreiterungProfile' , 'Profile');
      this.dictionaryDe.set('lblBlendrahmenverbreiterungKombination' , 'Kombination');
      this.dictionaryDe.set('lblBlendrahmenverbreiterungOben' , 'Oben');
      this.dictionaryDe.set('lblBlendrahmenverbreiterungLinks' , 'Links');
      this.dictionaryDe.set('lblBlendrahmenverbreiterungRechts' , 'Rechts');
      this.dictionaryDe.set('lblBlendrahmenverbreiterungUnten' , 'Unten');
      this.dictionaryDe.set('lblDoorConfigurationGrundform' , 'Grundform (Außenansicht);');
      this.dictionaryDe.set('lblHome' , 'Startseite');
      this.dictionaryDe.set('lblRadierer' , 'Alle temporär gespeicherten Türen löschen');
      this.dictionaryDe.set('lblDelete' , 'Löschen');
      this.dictionaryDe.set('lblApply' , 'Übernehmen');
      this.dictionaryDe.set('lblNameBezeichungSuchbar' , 'Name oder Beschreibung eingeben');
      this.dictionaryDe.set('lblColorSuchbar' , 'Name oder Nummer eingeben');
      this.dictionaryDe.set('lblGlasSuchePlaceholder' , 'Name eingeben');
      this.dictionaryDe.set('lblNettopreis' , 'voraussichtlicher Nettopreis:');
      this.dictionaryDe.set('lblAddDoor' , 'Haustüranlage erstellen');
      this.dictionaryDe.set('lblOwnImages' , 'Eigene Bilder');
      this.dictionaryDe.set('lblExistingImages' , 'Existierende Bilder');
      this.dictionaryDe.set('lblLoadOwnFile' , 'Eigene Datei laden');
      this.dictionaryDe.set('lblOfferThermNotSelected' , 'nicht gewählt');
      this.dictionaryDe.set('lblSettingsLayout' , 'Layout');
      this.dictionaryDe.set('lblSettingsLayoutAdressTop' , 'Adresse, von oben');
      this.dictionaryDe.set('lblSettingsLayoutAdressLeft' , 'Adresse, von links');
      this.dictionaryDe.set('lblSettingsLayoutMarginFromTop' , 'Abstand von oben');
      this.dictionaryDe.set('lblSettingsLayoutMarginFromLeft' , 'Abstand von links');
      this.dictionaryDe.set('lblSettingsLayoutMarginFromBottom' , 'Abstand von unten');
      this.dictionaryDe.set('lblSettingsLayoutMarginFromRight' , 'Abstand von rechts');
      this.dictionaryDe.set('lblSettingsLayoutDateTop' , 'Datum, von oben');
      this.dictionaryDe.set('lblSettingsLayoutDateLeft' , 'Datum, von links');
      this.dictionaryDe.set('lblSettingsLayoutFonTop' , 'Telefon/Fax, von oben');
      this.dictionaryDe.set('lblSettingsLayoutFonLeft' , 'Telefon/Fax, von links');
      this.dictionaryDe.set('lblSettingsLayoutOfferTop' , 'Angebotstext, von oben');
      this.dictionaryDe.set('lblSettingsLayoutOfferLeft' , 'Angebotstext, von links');
      this.dictionaryDe.set('lblSettingsLayoutOffer2Top' , 'Angebotstext 2. Seite, von oben');
      this.dictionaryDe.set('lblSettingsLayoutOffer2Left' , 'unterer Seitenrand');
      this.dictionaryDe.set('lblSettingsLayoutPrintOption' , 'Druckoptionen');
      this.dictionaryDe.set('lblSettingsLayoutPrintOption1' , 'Schnittzeichnung der Profile');
      this.dictionaryDe.set('lblSettingsLayoutPrintOption2' , 'Hinweise zur Holzstruktur');
      this.dictionaryDe.set('lblSettingsLayoutPrintOption3' , 'Warnungen zur Zubehörkombinierbarkeit');
      this.dictionaryDe.set('lblSettingsLayoutPrintOption4' , 'Hinweise zum U-Wert');
      this.dictionaryDe.set('lblSettingsLayoutPrintOption5' , 'Information zum Kaba experT');
      this.dictionaryDe.set('lblSettingsLayoutHeaderFooter' , 'Kopf- und Fußzeile');
      this.dictionaryDe.set('lblSettingsLayoutHeader' , 'Briefkopf');
      this.dictionaryDe.set('lblSettingsLayoutFooter' , 'Fußzeile');
      this.dictionaryDe.set('lblSettingsLayoutPdfExportOnly' , 'nur bei PDF-Export');
      this.dictionaryDe.set('lblSprossenHeader' , 'Sprossen');
      this.dictionaryDe.set('lblSprossenVerteilen' , 'Sprossen positionieren');
      this.dictionaryDe.set('lblAddSprosse' , 'Sprossen hinzufügen');
      this.dictionaryDe.set('lblSprossenInfo' , 'Sie können die hinzugefügten Sprossen direkt im Türbild verschieben.');
      this.dictionaryDe.set('lblSprossenSenkrecht' , 'Senkrecht');
      this.dictionaryDe.set('lblSprossenTSprosse' , 'T-Sprosse');
      this.dictionaryDe.set('lblSprossenWidth' , 'Sprossenbreiten');
      this.dictionaryDe.set('lblSprossenPosition' , 'Position');
      this.dictionaryDe.set('lblSprosseWaagerecht' , 'Waagerecht');
      this.dictionaryDe.set('lblSprosseFalling' , 'Schräg fallend');
      this.dictionaryDe.set('lblSprosseRising' , 'Schräg steigend');
      this.dictionaryDe.set('lblSprosseGleicheVerteilung' , 'Gleichmäßige Sprossenverteilung');
      this.dictionaryDe.set('lblSprosseEdit' , ' Sprosse bearbeiten');
      this.dictionaryDe.set('lblSprosseBreite' , 'Breite in mm');
      this.dictionaryDe.set('lblSprosseAbstand' , 'Abstand rechts/oben in mm');
      this.dictionaryDe.set('lblSprosseForward' , 'Nach vorne');
      this.dictionaryDe.set('lblSprosseToFront' , 'In den Vordergrund');
      this.dictionaryDe.set('lblSprosseSendBack' , 'Nach hinten');
      this.dictionaryDe.set('lblSprosseToBackground' , 'In den Hintergrund');
      this.dictionaryDe.set('lblSprosseDelete' , 'Sprosse löschen');
      this.dictionaryDe.set('lblFarblichabgesetzt1' , 'Diese Füllung ist farblich absetzbar. Wechseln Sie in den Reiter');
      this.dictionaryDe.set('lblFarblichAbgesetzt2' , 'um die Füllungsfarbe zu ändern.');
      this.dictionaryDe.set('lblDoorCopy' , 'Tür kopieren');
      this.dictionaryDe.set('lblDoorConfigurationPanelWingCoveredInfo' , 'Eine flügelüberdeckende Füllung im Seitenteil ist ' +
        'nur mit einem senkrechten Blindflügel möglich, Änderung der Blindflügel unter Bauform.');
      this.dictionaryDe.set('lblEmailHeader' , 'E-Mail senden');
      this.dictionaryDe.set('lblEmailBetreff' , 'Betreff');
      this.dictionaryDe.set('lblEmailTo' , 'An');
      this.dictionaryDe.set('lblEmailCc' , 'Cc');
      this.dictionaryDe.set('lblEmailBcc' , 'Bcc');
      this.dictionaryDe.set('lblEmailSend' , 'Senden');
      this.dictionaryDe.set('lblEmailSendOwnProgram' , 'E-Mail-Programm');
      this.dictionaryDe.set('lblEmailPickerName' , 'Name');
      this.dictionaryDe.set('lblEmailPickerEmail' , 'E-Mail');
      this.dictionaryDe.set('lblAddProductTitle' , 'Position hinzufügen');
      this.dictionaryDe.set('lblCopyProduct' , 'Position kopieren');
      this.dictionaryDe.set('lblEditProduct' , 'Position bearbeiten');
      this.dictionaryDe.set('lblRemoveProduct' , 'Position löschen');
      this.dictionaryDe.set('lblOfferJobAdd' , 'Dienstleistung zum Angebot hinzufügen');
      this.dictionaryDe.set('lblPositionJobAdd' , 'Dienstleistung zur Position hinzufügen');
      this.dictionaryDe.set('lblOfferPrePostText' , 'Vor- und Nachtexte');
      this.dictionaryDe.set('lblImpressum' , 'Impressum');
      this.dictionaryDe.set('lblVersionsinfo' , 'Versionsinfo');
      this.dictionaryDe.set('lblSettingsLayoutDeleteHeader' , 'Kopfzeile löschen');
      this.dictionaryDe.set('lblSettingsLayoutDeleteFooter' , 'Fußzeile löschen');
      this.dictionaryDe.set('lblSettingsMainHeader' , 'Einstellungen');
      this.dictionaryDe.set('lblSettingsPreisCurrencyUnit' , 'Währung');
      this.dictionaryDe.set('lblSettingsPreisCurrencyValue' , 'Währungsfaktor');
      this.dictionaryDe.set('lblSettingsPreisValue' , 'Preisfaktor');
      this.dictionaryDe.set('lblSettingsPreisVendorDiscount' , 'HändlerRabatt');
      this.dictionaryDe.set('lblSettingsPreisTollValue' , 'Mehrwertsteuersatz in %');
      this.dictionaryDe.set('lblSettingsPreisTollUnit' , 'Bezeichnung (Steuer);');
      this.dictionaryDe.set('lblSettingsPreisEinzelPreiseAnzeigen' , 'Einzelpreise (Ja/Nein);');
      this.dictionaryDe.set('lblSettingsPreisNettoPreiseAnzeigen' , 'vorauss. Netto-Preis anzeigen');
      this.dictionaryDe.set('lblSettingsPreisAktion1' , 'Aktion 21150');
      this.dictionaryDe.set('lblSettingsPreisAktionHeader' , 'Aktionen');
      this.dictionaryDe.set('lblSettingsPreisAktion2' , 'Winter-Aktion 2015');
      this.dictionaryDe.set('lblSettingsPreis' , 'Preisbildung');
      this.dictionaryDe.set('lblDeleteConfirmationMsg' , 'Möchten Sie diese Tür wirklich löschen?');
      this.dictionaryDe.set('lblDeleteConfirmationMsgTextmodul' , 'Möchten Sie dieses Textmodul wirklich löschen?');
      this.dictionaryDe.set('lblDeleteConfirmationMsgDoorWithOffer' , 'Zu dieser Tür wurde ein Angebot erstellt. ' +
        'Wenn Sie die Tür löschen, wird sie auch aus dem Angebot gelöscht. Möchten Sie diese Tür wirklich löschen?');
      this.dictionaryDe.set('lblPositionDeleteConfirmationMsg' , 'Möchten Sie diese Position wirklich löschen?');
      this.dictionaryDe.set('lblJobDeleteConfirmationMsg' , 'Möchten Sie diese Dienstleistung wirklich löschen?');
      this.dictionaryDe.set('lblDeleteUnsavedConfirmationMsg' , 'Möchten Sie wirklich alle temporären Türen löschen?');
      this.dictionaryDe.set('lblPreisAufAnfrage' , 'Preis auf Anfrage');
      this.dictionaryDe.set('lblPermanentSavedOffers' , 'Dauerhaft gespeicherte Angebote');
      this.dictionaryDe.set('lblTempOffers' , 'Temporär gespeicherte Angebote');
      this.dictionaryDe.set('lblEditCustomer' , 'Kunden bearbeiten');
      this.dictionaryDe.set('lblDeleteCustomer' , 'Kunden löschen');
      this.dictionaryDe.set('lblDeleteCustomerConfirmationMsg' , 'Möchten Sie diesen Kunden wirklich löschen');
      this.dictionaryDe.set('lblCustomerCompany' , 'Firmenname');
      this.dictionaryDe.set('lblCustomerStammdaten' , 'Stammdaten');
      this.dictionaryDe.set('lblCustomerKontakt' , 'Kontakt');
      this.dictionaryDe.set('lblCustomerAdress' , 'Anschrift und Rechnungsadresse');
      this.dictionaryDe.set('lblCustomerFirma' , 'Firma');
      this.dictionaryDe.set('lblCustomerPrivatPerson' , 'Privatperson');
      this.dictionaryDe.set('lblCustomerLieferadresse' , 'Abweichende Lieferadresse');
      this.dictionaryDe.set('lblPassword' , 'Passwort');
      this.dictionaryDe.set('lblOk' , 'Ok');
      this.dictionaryDe.set('lblNewPassword' , 'Neues Passwort');
      this.dictionaryDe.set('lblRepeatNewPassword' , 'Wiederholung');
      this.dictionaryDe.set('lblPaswordDidNotMatch' , 'Die Passwörter stimmten nicht überein. Bitte versuchen Sie es erneut.');
      this.dictionaryDe.set('lblWrongPassword' , 'Falsches Passwort.');
      this.dictionaryDe.set('lblSprossenHidenText' , 'Bitte wählen Sie eine der Modellreihen geschlossen, ' +
        'nur Glas oder Motivverglasung, um eine Sprosse zu erfassen');
      this.dictionaryDe.set('lblBaseFunction' , 'Grundfunktionen');
      this.dictionaryDe.set('lblBereich' , 'Bereich markieren');
      this.dictionaryDe.set('lblEbenen' , 'Ebenen');
      this.dictionaryDe.set('lblLizenznummer' , 'Lizenznummer');
      this.dictionaryDe.set('lblFirma' , 'Firma');
      this.dictionaryDe.set('lblTelefon' , 'Telefon');
      this.dictionaryDe.set('lblFax' , 'Fax');
      this.dictionaryDe.set('lblAnschrift' , 'Anschrift');
      this.dictionaryDe.set('lblStrasse' , 'Straße');
      this.dictionaryDe.set('lblPLZ' , 'PLZ');
      this.dictionaryDe.set('lblStadt' , 'Stadt');
      this.dictionaryDe.set('lblSchweizer' , 'Schweizer Einstellungen');
      this.dictionaryDe.set('lblStatusabfrage' , 'Statusabfrage');
      this.dictionaryDe.set('lblHintergrund' , 'Hintergrund');
      this.dictionaryDe.set('lblVordach' , 'Vordach');
      this.dictionaryDe.set('lblNachtdarstellung' , 'Nachtdarstellung');
      this.dictionaryDe.set('lblRechteck' , 'Rechteck');
      this.dictionaryDe.set('lblSchliessen' , 'Form schliessen');
      this.dictionaryDe.set('lblCompanyName' , 'Hartwig & Führer GmbH & Co. KG');
      this.dictionaryDe.set('lblProgrammversion' , 'Programmversion');
      this.dictionaryDe.set('lblDatenbankversion' , 'Datenbankversion');
      this.dictionaryDe.set('lblKundendienst' , 'Technischer Kundendienst');
      this.dictionaryDe.set('lblMessezentrum' , 'Messezentrum');
      this.dictionaryDe.set('lblProgrammfreigeschaltet' , 'Das Programm ist freigeschaltet bis zum');
      this.dictionaryDe.set('lblChooseColors' , 'Farben wählen');
      this.dictionaryDe.set('lblSchatten' , 'Schatten');
      this.dictionaryDe.set('lblTextur' , 'Textur');
      this.dictionaryDe.set('lblFarbe' , 'Farbe');
      this.dictionaryDe.set('lblInHintergrund' , 'in den Hintergrund');
      this.dictionaryDe.set('lblInVordergrund' , 'in den Vordergrund');
      this.dictionaryDe.set('lblFixieren' , 'Fixieren');
      this.dictionaryDe.set('lblPerspektivisch' , 'Perspektivisch');
      this.dictionaryDe.set('lblRechteckig' , 'Rechteckig');
      this.dictionaryDe.set('lblAccessoires' , 'Accessoires');
      this.dictionaryDe.set('lblLampen' , 'Lampen');
      this.dictionaryDe.set('lblWandverkleidung' , 'Wandverkleidung');
      this.dictionaryDe.set('lblFassadenelemente' , 'Fassadenelemente');
      this.dictionaryDe.set('lblOverviewOfServices' , 'Übersicht Ihrer Dienstleistungen');
      this.dictionaryDe.set('lblKommission' , 'Projekt');
      this.dictionaryDe.set('lblDienstleistungen' , 'Dienstleistungen');
      this.dictionaryDe.set('lblTextmodule' , 'Textmodule');
      this.dictionaryDe.set('lblSettingsAddTextmodul' , 'Textmodul hinzufügen');
      this.dictionaryDe.set('lblBeforeAfterTexts' , 'Vor-/Nachtexte');
      this.dictionaryDe.set('lblDownload' , 'Download');
      this.dictionaryDe.set('lblSonderverbreiterung' , 'Sonderverbreiterung');
      this.dictionaryDe.set('lblmm' , 'mm');
      this.dictionaryDe.set('lblGesamt' , 'Gesamt');
      this.dictionaryDe.set('lblCustomerDuplicate' , 'In Ihren Kundendaten existieren bereits ' +
        'ähnliche Einträge. Meinten Sie eventuell einen der folgenden Kunden?');
      this.dictionaryDe.set('lblNeuerKunde' , 'Neuer Kunde');
      this.dictionaryDe.set('lblVorhandeneKunden' , 'Vorhandene Kunden');
      this.dictionaryDe.set('lblStatusabfrage' , 'Statusabfrage');
      this.dictionaryDe.set('lblAngebotsnummer' , 'Angebotsnummer');
      this.dictionaryDe.set('lblBestellt' , 'Bestellt');
      this.dictionaryDe.set('lblErfasst' , 'Erfasst');
      this.dictionaryDe.set('lblLiefertermin' , 'vorauss. Liefertermin');
      this.dictionaryDe.set('lblProduktionsstart' , 'Produktionsstart');
      this.dictionaryDe.set('lblProduktionsende' , 'Produktionsende');
      this.dictionaryDe.set('lblVerladen' , 'Verladen');
      this.dictionaryDe.set('lblBerechnet' , 'Berechnet');
      this.dictionaryDe.set('lblAngebot' , 'Angebot');
      this.dictionaryDe.set('lblRechnung' , 'Rechnung');
      this.dictionaryDe.set('lblKW' , 'KW');
      this.dictionaryDe.set('lblLadeStatus' , 'Lade Status...das kann nach einem Neustart der Anwendung etwas dauern.');
      this.dictionaryDe.set('lblSinglePosition' , 'Position');
      this.dictionaryDe.set('lblCreatPresentation' , 'Präsentation erstellen');
      this.dictionaryDe.set('lblDeleteConfirmationMsgMulti' , 'Möchten Sie diese Türen wirklich löschen?');
      this.dictionaryDe.set('lblDeleteConfirmationMsgOfferMulti' , 'Möchten Sie diese Angebote wirklich löschen?');
      this.dictionaryDe.set('lblDeleteConfirmationMsgOffer' , 'Möchten Sie dieses Angebot wirklich löschen?');
      this.dictionaryDe.set('lblDeleteConfirmationPositionMsg' , 'Möchten Sie diese Position wirklich löschen? ' +
        'Gelöschte Türen sind nicht mehr in der Türenübersicht zu sehen.');
      this.dictionaryDe.set('lblOfferAdd' , 'Angebot hinzufügen');
      this.dictionaryDe.set('lblOfferEdit' , 'Angebot bearbeiten');
      this.dictionaryDe.set('lblOfferSave' , 'Angebot dauerhaft speichern');
      this.dictionaryDe.set('lblOfferConstruction' , 'Konstruktion');
      this.dictionaryDe.set('lblOfferGeneralInfo' , 'Allgemeine Angaben');
      this.dictionaryDe.set('lblDeleteAllOffers' , 'Alle temporär gespeicherten Angebot löschen');
      this.dictionaryDe.set('lblPlsInsertHausnummer' , 'Bitte geben Sie die gewünschte Hausnummer an.');
      this.dictionaryDe.set('lblHausnummer' , 'Hausnummer');
      this.dictionaryDe.set('lblUWertArea' , 'A (gesamt);');
      this.dictionaryDe.set('lblUWertHta' , 'U-Wert HTA');
      this.dictionaryDe.set('lblPositionDetailsProperies' , 'Türeigenschaften');
      this.dictionaryDe.set('lblVerriegelungArtNr' , 'Art.Nr.');
      this.dictionaryDe.set('lblVerriegelungMehrpreis' , 'Mehrpreis');
      this.dictionaryDe.set('lblVerriegelungAlsAlternative' , 'als Alternative');
      this.dictionaryDe.set('lblNewCustomer' , 'Neuer Kunde');
      this.dictionaryDe.set('lblDoorNotSaveableReason' , 'Für diese Tür kann kein Angebot erstellt werden da noch ' +
        'Fehlermeldungen existieren. Bitte klicken Sie auf den Button mit dem Stift (Tür bearbeiten);, ' +
        'die Fehlermeldungen werden rechts unten angezeigt.');
      this.dictionaryDe.set('lblDokumenttext' , 'Dokumententexte');
      this.dictionaryDe.set('lblVersion' , 'Version:');
      this.dictionaryDe.set('lblNavbarVordach' , 'Vordach');
      this.dictionaryDe.set('lblJobImage' , 'Bild');
      this.dictionaryDe.set('lblSettingsJobDelete' , 'Bild entfernen');
      this.dictionaryDe.set('lblPrintDoor' , 'Bild drucken');
      this.dictionaryDe.set('lblDownloadDoor' , 'Bild herunterladen');
      this.dictionaryDe.set('lblKeinHolzdekotBeiClassicLine' , 'Holzdekore sind bei der Zierleiste Classic Line nicht möglich.');
      this.dictionaryDe.set('lblDoorConfigurationPanelWingCoveredDuoInfo' , 'Bei flügelüberdeckenden Füllungen können nur ' +
        'die Profilsysteme KO 80 HD, KO 80 HDA, KOtherm und Softtherm eingesetzt werden.');
      this.dictionaryDe.set('lblAccessoryDoesNotMatchInColor' , 'Dieses Zubehörteil passt farblich nicht zu den bereits ausgewählten!');
      this.dictionaryDe.set('lblAccessoryNotWithTherm' , 'Diese Türbänder können nur bei Therm-Profilen eingesetzt werden!');
      this.dictionaryDe.set('lblAccessoryOnlyWithSpecificModel' , 'Das Zubehör 22089 kann nur bei Modelltüren 3400 und 3600 eingesetzt werden.');
      this.dictionaryDe.set('lblAccessoryNotDeliverable' , 'Dieses Zubehörteil ist nicht mehr lieferbar!');
      this.dictionaryDe.set('lblAccessoryErsatzartikel' , 'Ersatzartikel');
      this.dictionaryDe.set('lblDoorConfigurationColorPartialCarbon' , 'Carbon Applikation');
      this.dictionaryDe.set('lblDoorConfigurationColorPartialStone' , 'Naturstein Applikation');
      this.dictionaryDe.set('lblFabrlichAbsetzbarAlert' , 'Achtung, Füllungsplatte farblich absetzbar.');
      this.dictionaryDe.set('lblJa' , 'Ja');
      this.dictionaryDe.set('lblNein' , 'Nein');
      this.dictionaryDe.set('lblKratzschutzEinlegen' , 'Soll der Kratzschutz eingelegt werden? Aufpreis ');
      this.dictionaryDe.set('lblKratzschutzNichtBeiFluegelueberdeckend' , 'Dieser Zubehörartikel ist nur für flügelüberdeckende Füllungen möglich.');
      this.dictionaryDe.set('lblAdditionalHingeWarning' , 'Dieses Türband passt nicht zu den vorhanden Türbändern und kann nicht ausgewählt werden.');
      this.dictionaryDe.set('lblAddAlsAlternative' , 'Als Alternative hinzufügen');
      this.dictionaryDe.set('lblInklusive' , 'Inklusive');
      this.dictionaryDe.set('lblSpiegelWarning' , 'Das Zubehör 23089 kann bei Modelltüren und Glastüren nicht eingesetzt werden.');
      this.dictionaryDe.set('lblChangeGlas' , 'Anderes Glas wählen');
      this.dictionaryDe.set('lblChangeFuellung' , 'Andere Füllung wählen');
      this.dictionaryDe.set('lblAddJamb' , 'Oberlichttyp ändern');
      this.dictionaryDe.set('lblSichtbarerFuellungsbereichAlert1' , 'Der verfügbare Bereich im');
      this.dictionaryDe.set('lblSichtbarerFuellungsbereichAlert2Glas' , 'ist zu groß für das gewählte Glas. Die Maximalmaße des Glases sind');
      this.dictionaryDe.set('lblSichtbarerFuellungsbereichAlert2Fuellung' , 'ist zu klein für die gewählte Füllung. Die Minimalmaße der Füllung sind');
      this.dictionaryDe.set('lblKeepGlas' , 'Glas trotzdem übernehmen');
      this.dictionaryDe.set('lblOpeningInside' , 'Einwärts öffnend');
      this.dictionaryDe.set('lblOpeningOutside' , 'Auswärts öffnend');
      this.dictionaryDe.set('lblPanel' , 'Füllung');
      this.dictionaryDe.set('lblMotivverglasung' , 'Motivverglasung');
      this.dictionaryDe.set('lblStandardverglasung' , 'Standardverglasung');
      this.dictionaryDe.set('lblSonderverglasung' , 'Sonderverglasung');
      this.dictionaryDe.set('lblSeitenteile' , 'Seitenteile anzeigen');
      this.dictionaryDe.set('lblSelectDifferentSpiegel' , 'Bitte wählen Sie Artikel 23089.');
      this.dictionaryDe.set('lblKeepFuellung' , 'Füllung trotzdem übernehmen');
      this.dictionaryDe.set('lblSelectProjectName' , 'Bitte geben Sie einen Projektnamen für die Haustüranlage an. ');
      this.dictionaryDe.set('lblLichteHoehe' , 'Lichte Höhe in mm');
      this.dictionaryDe.set('lblLichteBreite' , 'Lichte Breite in mm');
      this.dictionaryDe.set('lblHoehenpaketHeader' , 'Höhenpaket');
      this.dictionaryDe.set('lblHoehenpaketNeeded' , 'Aufgrund der eingestellten Höhe, sollte ein Höhenpaket erfasst werden.');
      this.dictionaryDe.set('lblHoehenpaketRecommendation' , 'Außerdem möchten wir Ihnen dreiteilige Türbänder ' +
        '(Artikel 10206); empfehlen. Diese können Sie im Reiter Zubehör erfassen.');
      this.dictionaryDe.set('lblHoehenpaketDisclaimer' , 'Wünschen Sie kein Höhenpaket, kann von ' +
        'Hartwig & Führer keine Gewährleistung übernommen werden.');
      this.dictionaryDe.set('lblApplyHoehenpaket' , 'Höhenpaket erfassen');
      this.dictionaryDe.set('lblCancelHoehenpaket' , 'Kein Höhenpaket erwünscht');
      this.dictionaryDe.set('lblDoorConfigurationAccessoryImages' , 'Bilder');
      this.dictionaryDe.set('lblVoreinstellungen' , 'Voreinstellungen');
      this.dictionaryDe.set('lblExportImport' , 'Export/ Import');
      this.dictionaryDe.set('lblAllgemein' , 'Allgemein');
      this.dictionaryDe.set('lblZubehor' , 'Zubehor');
      this.dictionaryDe.set('lblSonstiges' , 'Sonstiges');
      this.dictionaryDe.set('lblExakt' , 'Exakte Suche');
      this.dictionaryDe.set('lblDoorPreis' , 'Preis');
      this.dictionaryDe.set('lblNoteDeleteConfirmationMsg' , 'Möchten Sie dieses Textmodule wirklich löschen?');
      this.dictionaryDe.set('lblSelectTitleName' , 'Bitte geben Sie den Titel und die Beschreibung der neue Dienstleistung an.');
      this.dictionaryDe.set('lblDoorConfigurationPositionDetails' , 'Eigenschaften');
      this.dictionaryDe.set('lblNameEmptyNotAllowed' , 'Das Projekt darf nicht leer sein. Die Änderung wurde nicht gespeichert.');
      this.dictionaryDe.set('lblDocuments' , 'Dokumente');
      this.dictionaryDe.set('lblWordExport' , 'Word Export');
      this.dictionaryDe.set('lblShowDocument' , 'Dokument anzeigen');
      this.dictionaryDe.set('lblSendAsEmail' , 'Per E-Mail versenden');
      this.dictionaryDe.set('lblOfferBestellung' , 'Bestellung');
      this.dictionaryDe.set('lblEstimatedDeliveryDate' , 'ca. Liefertermin');
      this.dictionaryDe.set('lblKopieAn' , 'Kopie an');
      this.dictionaryDe.set('lblBestellen' , 'Bestellen');
      this.dictionaryDe.set('lblOnlineBestellung' , 'Online-Bestellung');
      this.dictionaryDe.set('lblFuellungsgroessenWarningFuellung' , 'Füllungsgröße - Füllung');
      this.dictionaryDe.set('lblFuellungsgroessenWarningGlas' , 'Füllungsgröße - Glas');
      this.dictionaryDe.set('lblFuellungsgroessenWarningOberlicht' , 'Füllungsgröße - Oberlichtglas');
      this.dictionaryDe.set('lblBestellenExplanation' , 'Mit dem Klick auf Bestellen wird eine E-Mail an KOMPOtherm versandt. Geben Sie im Feld ' +
        'Kopie an Ihre E-Mail Adresse ein, wenn Sie eine Kopie der Nachricht erhalten möchten.');
      this.dictionaryDe.set('lblDoorHasOffer' , 'Angebot vorhanden');
      this.dictionaryDe.set('lblAdminUserOverview' , 'Übersicht');
      this.dictionaryDe.set('lblAdminUserNewUser' , 'Neue Nutzer anlegen');
      this.dictionaryDe.set('lblAdminUserEditUser' , 'Nutzer Einstellungen bearbeiten');
      this.dictionaryDe.set('lblAdminUserInfo' , 'Info / Hilfe');
      this.dictionaryDe.set('lblAdminUserTableEdit' , 'Bearbeiten');
      this.dictionaryDe.set('lblAdminUserTableUserNr' , 'Nutzungsnummer');
      this.dictionaryDe.set('lblAdminUserTableCompany' , 'Firma');
      this.dictionaryDe.set('lblAdminUserTablePhone' , 'Telefonnummer');
      this.dictionaryDe.set('lblAdminUserTableFax' , 'Faxnummer');
      this.dictionaryDe.set('lblAdminUserTableMail' , 'Email');
      this.dictionaryDe.set('lblAdminUserTableSwiss' , 'Schweizer Einstellungen');
      this.dictionaryDe.set('lblAdminUserTableUserName' , 'Benutzername');
      this.dictionaryDe.set('lblAdminUserTableFirstName' , 'Vorname');
      this.dictionaryDe.set('lblAdminUserTableLastName' , 'Nachname');
      this.dictionaryDe.set('lblAdminUserTableActive' , 'Aktiv');
      this.dictionaryDe.set('lblAdminUserTableDelete' , 'Löschen');
      this.dictionaryDe.set('lblAdminUserUserEdit' , 'Nutzer bearbeiten');
      this.dictionaryDe.set('lblAdminUserSaveEdit' , 'Speichern');
      this.dictionaryDe.set('lblAdminUserCancel' , 'Abbrechen');
      this.dictionaryDe.set('lblAdminUserAddNew' , 'Anlegen');
      this.dictionaryDe.set('lblAdminUserEmptyUserNameNotAllowed' , 'Benutzername muss angegeben werden');
      this.dictionaryDe.set('lblAdminUserMinlength' , 'Das Feld muss mindestens 3 Zeichen haben');
      this.dictionaryDe.set('lblAdminUserEmptyLastNameNotAllowed' , 'Nachname muss angegeben werden');
      this.dictionaryDe.set('lblAdminUserEmptyMailNotAllowed' , 'Email muss angegeben werden');
      this.dictionaryDe.set('lblAdminUserNoValidEmail' , 'Keine gültige Email');
      this.dictionaryDe.set('lblAdminUserNoValidPhoneNumber' , 'Ungültige Telefonnummer');
      this.dictionaryDe.set('lblAdminUserPasswordNotValid' , 'Ungültiges Passwort');
      this.dictionaryDe.set('lblAdminUserPhoneNumberPattern' , '[0-9 +]*');
      this.dictionaryDe.set('lblAdminUserGetNewPassword' , 'Zufälliges Passwort');
      this.dictionaryDe.set('lblAdminUserSavePassword', 'Passwort ändern');
  }
  public LOCALE: any;
  public getLabelByKey(key: string): string {
   return this.dictionaryDe.get(key);
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/services/localization-service2.service.ts